<template>
  <div id="hpp-app">
    <Cart/>
  </div>
</template>

<script>
import Cart from './components/Cart.vue';

export default {
  name: 'Hpp',
  components: {
    Cart,
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/style/App.scss";

</style>
